import Image from "next/image";

import { GrainOverlay } from "@/components/ui/grain-overlay";
import { cn } from "@/lib/utils";

/** Figma Image frame background (5584:27234 / 5584:27289). */
const TEAL_BASE = "rgb(236, 248, 245)";

export function NavPreviewTealGradientBackground() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-0 overflow-hidden bg-[rgb(236,248,245)]"
      >
        <div
          className="absolute top-[-522px] left-[-607px] size-[1080px] overflow-hidden bg-size-[843.8485107421875px_843.8485107421875px] bg-top-left bg-no-repeat"
          style={{
            backgroundImage: `url(/images/nav/gradient-teal.png), linear-gradient(90deg, ${TEAL_BASE} 0%, ${TEAL_BASE} 100%)`,
          }}
        >
          <TealGradientEllipse
            className="top-[487px] left-[-248px] h-[876px] w-[1410px]"
            insetClassName="inset-[-34.25%_-21.28%]"
            src="/images/nav/insights-gradient/ellipse-5127.svg"
          />
          <TealGradientEllipse
            className="top-[-967px] left-[-490px] size-[1410px]"
            insetClassName="inset-[-35.46%]"
            src="/images/nav/insights-gradient/ellipse-5129.svg"
          />
        </div>

        <TealGradientEllipse
          className="top-[-784px] left-[-91px] size-[1410px]"
          insetClassName="inset-[-21.28%]"
          src="/images/nav/insights-gradient/ellipse-5128.svg"
        />
      </div>
      <GrainOverlay
        baseFrequency={0.85}
        numOctaves={2}
        contrast={1.8}
        opacity={0.28}
        blendMode="soft-light"
      />
    </>
  );
}

function TealGradientEllipse({
  className,
  insetClassName,
  src,
}: {
  className: string;
  insetClassName: string;
  src: string;
}) {
  return (
    <div className={cn("pointer-events-none absolute", className)}>
      <div className="relative size-full">
        <div className={cn("absolute", insetClassName)}>
          <Image
            src={src}
            alt=""
            fill
            unoptimized
            className="max-w-none object-fill"
          />
        </div>
      </div>
    </div>
  );
}
